import getFeature from "@template/helpers/getFeature";

const isFeatureEnabled = async featureName => {
  const feature = await getFeature(featureName);

  return feature ? feature.isEnabled() : false;
};

export default isFeatureEnabled;
